import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceAuth {
    lookupService = new APIServiceLookUp();

    async staffLogin(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}staff/staffLogin`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async staffRefresh() {
        var serviceType = "POST";
        var url = `${API_URL}staff/staffRefresh`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, {}, '');
    }

    async updateName(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updateName`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateEmail(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updateEmail`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updatePhone(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updatePhone`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updatePassword() {
        var serviceType = "POST";
        var url = `${API_URL}staff/updatePassword`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, {}, '');
    }

    async disableAccount() {
        var serviceType = "POST";
        var url = `${API_URL}staff/disableAccount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, {}, '');
    }

    async getAllStaff(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/getAllStaff`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateStaffById(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updateStaffById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async sendReset(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/sendReset`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async staffCreate(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}staff/setStaff`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateStaff(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updateStaff`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updatePosPassword(body) {
        var serviceType = "POST";
        var url = `${API_URL}auth/updatePosPassword`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }
}